import React from "react";
import {
    Box,
    FormControl,
    InputLabel,
    MenuItem,
    Pagination,
    PaginationItem,
    Select,
    SelectChangeEvent,
    Typography,
} from "@mui/material";
import { PAGINATION_STYLES, PAGE_SIZE_SELECT_STYLES } from "../../styles/paginationStyles";

type PaginationControlsProps = {
    showingLabel: string;
    page: number;
    pageCount: number;
    pageSize: number;
    onPageChange: (page: number) => void;
    onPageSizeChange: (pageSize: number) => void;
    disabled?: boolean;
};

export const PaginationControls: React.FC<PaginationControlsProps> = ({
    showingLabel,
    page,
    pageCount,
    pageSize,
    onPageChange,
    onPageSizeChange,
    disabled = false,
}) => {
    const handlePageChange = (_: React.ChangeEvent<unknown>, nextPage: number) => {
        onPageChange(nextPage);
    };

    const handlePageSizeChange = (e: SelectChangeEvent<number>) => {
        onPageSizeChange(Number(e.target.value));
    };

    if (pageCount <= 0) return null;

    return (
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 2 }}>
            <Typography sx={{ fontWeight: 600 }}>{showingLabel}</Typography>

            <Box sx={{ display: "flex", alignItems: "center", gap: 2, flexWrap: "wrap" }}>
                <FormControl size="small" sx={PAGE_SIZE_SELECT_STYLES.formControl} disabled={disabled}>
                    <InputLabel shrink>Por página</InputLabel>

                    <Select<number>
                        value={pageSize}
                        label="Por página"
                        onChange={handlePageSizeChange}
                        MenuProps={{
                            PaperProps: { sx: PAGE_SIZE_SELECT_STYLES.menuPaper },
                            MenuListProps: { sx: PAGE_SIZE_SELECT_STYLES.menuList },
                        }}
                    >
                        <MenuItem sx={PAGE_SIZE_SELECT_STYLES.menuItem} value={10}>10</MenuItem>
                        <MenuItem sx={PAGE_SIZE_SELECT_STYLES.menuItem} value={20}>20</MenuItem>
                        <MenuItem sx={PAGE_SIZE_SELECT_STYLES.menuItem} value={50}>50</MenuItem>
                        <MenuItem sx={PAGE_SIZE_SELECT_STYLES.menuItem} value={100}>100</MenuItem>
                    </Select>
                </FormControl>

                <Pagination
                    count={pageCount}
                    page={page}
                    onChange={handlePageChange}
                    size="medium"
                    showFirstButton
                    showLastButton
                    sx={PAGINATION_STYLES}
                    disabled={disabled}
                    renderItem={(item) => <PaginationItem {...item} />}
                />
            </Box>
        </Box>
    );
};














